import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 1600px;
    margin: auto;
    padding: 0 20px;
    margin-bottom: 5rem;

    @media (max-width: 1600px) {
        width: 100%;
        padding: 0 20px;
    }

    @media (max-width: 768px) {
        margin: auto;
        width: 100%;
        padding: 0;
        margin-bottom: 0;
    }
`

export const ContainerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: left;
    width: 100%;
`
